<!-- eslint-disable vue/eqeqeq -->
<template>
  <div
    class="navbar-container main-menu-content horizontal-layout navbar-floating horizontal-menu"
    v-if="!isSwitching"
    data-testid="horizontal-nav-menu">
    <div class="horizontal-menu-wrapper">
      <div
        class="header-navbar navbar-expand-sm navbar navbar-horizontal floating-nav navbar-shadow menu-border sp-nav-bar"
        role="navigation"
        data-menu="menu-wrapper"
        data-menu-type="floating-nav">
        <!-- Horizontal menu content-->
        <div class="navbar-container main-menu-content" data-menu="menu-container">
          <ul class="nav navbar-nav" id="main-menu-navigation" data-menu="menu-navigation">
            <li class="dropdown nav-item" v-if="userMenuPermissions()" data-menu="dropdown">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-users-dropdown">
                <span data-i18n="Dashboards"> <img src="../../assets/horizontalMenu/userMenu.png" alt="User Icon" /> Users </span>
              </a>
              
              <ul class="dropdown-menu">
                <li data-menu="" v-if="checkRolePermission('VIEW_APPROVED_APPLICANTS') || checkRolePermission('VIEW_REJECTED_APPLICANTS') || checkRolePermission('VIEW_PENDING_APPLICANTS') || checkRolePermission('VIEW_APPLICANTS')" id="New applicants">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/rightToWorkRequests/pending"
                    data-toggle="dropdown"
                    data-testid="nav-new-applicants">
                    <img src="../../assets/horizontalMenu/userMenu.png" alt="User Icon" style="margin-right:8px" /><span data-i18n="Analytics">New applicants</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="currentUserRole === 'ADMIN' && (checkRolePermission('VIEW_APPROVED_USERS') || checkRolePermission('VIEW_REJECTED_USERS') || checkRolePermission('VIEW_DELETED_USERS'))" id="Users">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/userList/approvedStaff"
                    data-toggle="dropdown"
                    data-testid="nav-users">
                    <img src="../../assets/horizontalMenu/userMenu.png" alt="User Icon" style="margin-right:8px" /><span data-i18n="Analytics">Users</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_MODAL_SHIFTS')" id="Model Shifts" v-show="checkAccess('Model Shifts')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/modelJobList"
                    data-toggle="dropdown"
                    data-testid="nav-model-shifts">
                    <img src="../../assets/horizontalMenu/shiftsMenu.png" alt="Model Shifts Icon" style="margin-right:8px" />
                    <span data-i18n="Analytics">Model Shifts</span>
                  </router-link>
                </li>
                <li
                  data-menu=""
                  v-if="currentUserRole != 'ADMIN' && currentUserRole != 'SUPER-ADMIN'"
                  v-show="checkRolePermission('VIEW_APPROVED_USERS') || checkRolePermission('VIEW_REJECTED_USERS') || checkRolePermission('VIEW_DELETED_USERS')"
                  id="Staff">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/nurseUsers/approvedUser"
                    data-toggle="dropdown"
                    data-testid="nav-staff">
                    <span data-i18n="Analytics"><img src="../../assets/horizontalMenu/user.svg" alt="User Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Staff</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_INVITED_MANAGERS')" id="Managers">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/managers/list"
                    data-toggle="dropdown"
                    data-i18n="eCommerce"
                    data-testid="nav-managers">
                    <span data-i18n="eCommerce"><img src="../../assets/horizontalMenu/user-plus.svg" alt="user plus Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Managers</span>
                  </router-link>
                </li>
                <li data-menu="" id="trustRole" v-if="checkRolePermission('VIEW_MASTER_ROLES') || checkRolePermission('VIEW_TRUST_ROLES')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/roles/list"
                    data-toggle="dropdown"
                    data-i18n="eCommerce"
                    data-testid="nav-role-permission">
                    <span data-i18n="Analytics"><img src="../../assets/horizontalMenu/framer.svg" alt="Framer Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Role Permission</span>
                  </router-link>
                </li>
                <li data-menu="" id="findAStaff" v-if="checkRolePermission('FIND_STAFF_USERS')" v-show="checkAccess('Find a Staff')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/search/staff/persona"
                    data-toggle="dropdown"
                    data-i18n="eCommerce"
                    data-testid="nav-find-staff">
                    <span data-i18n="eCommerce"><img src="../../assets/horizontalMenu/search.svg" alt="Search Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Find staff</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="dropdown nav-item"
              v-if="skillMenuPermission()"
              data-menu="dropdown">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                id="Skills"
                data-toggle="dropdown"
                data-testid="nav-skills-dropdown">
                <img src="../../assets/horizontalMenu/skillsMenu.png" alt="Skills Icon" /><span data-i18n="Apps">Skills</span>
              </a>
              <ul class="dropdown-menu">
                <li
                  data-menu=""
                  v-if="checkRolePermission('VIEW_MASTER_PERSONAS') || checkRolePermission('VIEW_TRUST_PERSONAS')"
                  id="list Persona">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/persona-list-configuration"
                    data-toggle="dropdown"
                    data-i18n="Chat"
                    data-testid="nav-persona-list">
                    <span data-i18n="Chat"><img src="../../assets/horizontalMenu/package.svg" alt="Package Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Persona List</span>
                  </router-link>
                </li>
                <li
                  data-menu=""
                  v-if="checkRolePermission('VIEW_PERSONA_MAPPINGS')"
                  id="Persona Mapping"
                  v-show="checkAccess('Shift skills')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/personaMappings/list"
                    data-toggle="dropdown"
                    data-i18n="Todo"
                    data-testid="nav-persona-mapping">
                    <span data-i18n="Todo"><img src="../../assets/horizontalMenu/tablet.svg" alt="Tablet Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Persona Mapping</span>
                  </router-link>
                </li>
                <li
                  data-menu=""
                  v-if="checkRolePermission('VIEW_MASTER_CAPABILITIES') || checkRolePermission('VIEW_MASTER_COMPETENCIES') || checkRolePermission('VIEW_MASTER_SKILLS')
                    || checkRolePermission('VIEW_TRUST_CAPABILITIES') || checkRolePermission('VIEW_TRUST_COMPETENCIES') || checkRolePermission('VIEW_TRUST_SKILLS') "
                  id="Skill Tree">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/skill-tree"
                    data-toggle="dropdown"
                    data-i18n="Todo"
                    data-testid="nav-skill-tree">
                    <span data-i18n="Todo"><img src="../../assets/horizontalMenu/tablet.svg" alt="Tablet Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Skill Tree</span>
                  </router-link>
                </li>
                <li data-menu="" id="Options" v-if="checkRolePermission('VIEW_THRESHOLD_RANGES_FOR_USER_COMFORT_PREFERENCE') && checkRolePermission('EDIT_THRESHOLD_RANGE_FOR_USER_COMFORT_PREFERENCE') && checkRolePermission('CREATE_THRESHOLD_RANGE_FOR_USER_COMFORT_PREFERENCE')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/confidence-threshold"
                    data-toggle="dropdown"
                    data-i18n="Typography"
                    data-testid="nav-threshold">
                    <span data-i18n="Typography"><img src="../../assets/horizontalMenu/list.svg" alt="List Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Threshold</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="dropdown nav-item"
              v-if="settingRolePermissions()"
              data-menu="dropdown">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                id="Settings"
                data-toggle="dropdown"
                data-testid="nav-settings-dropdown">
                <img src="../../assets/horizontalMenu/settingsMenu.png" alt="Settings Icon" /><span data-i18n="User Interface">Settings</span>
              </a>
              <ul class="dropdown-menu">
                <li
                  data-menu=""
                  v-if="checkRolePermission('VIEW_WEIGHT_ADJUSTER_SCALE')"
                  id="Weight Adjuster"
                  v-show="checkAccess('Eligible candidates and weight adjuster')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/weight-adjuster"
                    data-toggle="dropdown"
                    data-testid="nav-weight-adjuster">
                    <span data-i18n="Analytics"><img src="../../assets/horizontalMenu/sliders.svg" alt="Sliders Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Weight Adjuster</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_BAND_TYPES') || checkRolePermission('VIEW_ROLE_TYPES')" id="Options">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/options"
                    data-toggle="dropdown"
                    data-i18n="Typography"
                    data-testid="nav-options">
                    <span data-i18n="Typography"><img src="../../assets/horizontalMenu/list.svg" alt="List Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Options</span>
                  </router-link>
                </li>
                <!-- <li
                  data-menu=""
                  v-if="currentUserRole != 'SUPER-ADMIN' && currentUserRole != 'TRUST-ADMIN'"
                  id="System Settings">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/settings"
                    data-toggle="dropdown"
                    data-i18n="Colors"
                    data-testid="nav-system-settings">
                    <ToolIcon /><span data-i18n="Colors">System Settings</span>
                  </router-link>
                </li> -->
                <li data-menu="" id="Drafted Shift Configuration" v-if="checkRolePermission('VIEW_CHECKLIST_FOR_DRAFTED_SHIFTS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/drafted/shift/configuration"
                    data-toggle="dropdown"
                    data-i18n="Colors"
                    data-testid="nav-drafted-shift-config">
                    <span data-i18n="Colors"><img src="../../assets/horizontalMenu/tool.svg" alt="Tool Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Drafted Shift Configurations</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_PRODUCT_CONFIGURATIONS')" id="Product Configurations">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/product-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-product-config">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/sliders.svg" alt="Sliders Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Product Configurations</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_PRIVACY_POLICIES')" id="Privacy Policy">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/privacy-policy"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-privacy-policy">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/file.svg" alt="File Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Privacy Policy</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_CHECKLIST_FOR_RATE_ESCALATION') || checkRolePermission('VIEW_RATE_APPROVAL_REASONS') || checkRolePermission('VIEW_RATE_TIER_CONFIGURATIONS') || checkRolePermission('VIEW_RATE_REJECTION_REASONS')" id="Rate escalation configuration" v-show="checkAccess('Rate Escalation')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/rate-esclation-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-rate-escalation">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/dollar-sign.svg" alt="Dollar Sign Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Rate escalation configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_BOOKING_RESTRICTION_REASONS')" id="Booking Restriction reasons">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/blockedReason/new"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-booking-restriction">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/align-left.svg" alt="Booking Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Booking Restriction reasons</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_HIFI_AWARD_REASONS')" id=" Hi Fi Award reasons">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/hiFiReason/new"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-hifi-award"><img src="../../assets/horizontalMenu/award.svg" alt="award Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />
                    <span data-i18n="Feather">Hi Fi Award reasons</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_AUTO_OFFER_CONFIGURATIONS')" id="Auto offer configuration" v-show="checkAccess('Auto-offer')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/autoOfferConfiguration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-auto-offer">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/rotate-ccw.svg" alt="Auto Offer Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />  Auto offer configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_NOTIFICATIONS_SETTINGS')" id="Notification Settings">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/notification-settings"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-notification-settings">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/bell.svg" alt="Notification Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Notification Settings</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_BAND_ROLETYPE_MAPPINGS')" id="Band - Role Type Mapping">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/restrict-range-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-band-role-mapping">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/server.svg" alt="Band Role Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Band - Role Type Mapping</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_STAFF_PROFILE_CONFIGURATIONS')" id="Staff Profile Configurations">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/staff-profile-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-staff-profile-config">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/user.svg" alt="User Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Staff Profile Configurations</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_NFI')" id="New Feature Introduction">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/new-feature-introduction"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-new-feature">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/triangle.svg" alt="Triangle Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px; transform: rotate(90deg);" /> New Feature Introduction</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_MASTER_CARE_SPECIALITIES')" id="Care Speciality Configuration">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/care/speciality/configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-care-speciality">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/plus.svg" alt="Care Speciality Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Care Speciality Configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_PAY_RATES_CONFIGURATION')" id="Pay Rates Configuration">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/pay-rate-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-pay-rates">
                    <span data-i18n="Feather"> <img src="../../assets/horizontalMenu/credit-card.svg" alt="Pay Rates Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Pay Rates Configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_SHIFT_CANCELLATION_REASONS')" id=" Report Cancellation reasons">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/reportCancellation/new"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-report-cancellation">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/list.svg" alt="Report Cancellation Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Report Cancellation reasons</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_RECOMMENDED_SHIFTS_CONFIGURATION')" id="Recommended Shifts Configuration">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/job-prediction-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-recommended-shifts">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/sliders.svg" alt="Recomended shift Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Recommended Shifts Configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_UNFILLED_SHIFTS_NUDGE_TIMER')" id="Unfilled Shifts Nudge Timer">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/unfilled-shifts-configuration"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-unfilled-shifts">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/sliders.svg" alt="Unfilled Shifts Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />  Unfilled Shifts Configuration</span>
                  </router-link>
                </li>
                <li data-menu="" id="Auto Acceptance Timer configuration" v-if="checkRolePermission('VIEW_AUTO_OFFER_CONFIGURATIONS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/autoAcceptanceTimerConfiguration"
                    data-toggle="dropdown">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/rotate-ccw.svg" alt="Auto Offer Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Auto Acceptance Timer configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_STAFF_REDEPLOYMENT_REASONS')" id=" Staff Redeployment Reason Configuration" v-show="checkAccess('Staff Redeployment')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/Redeployment-Reason-Configuration"
                    data-toggle="dropdown">
                    <span data-i18n="Feather" id="redeployment">  <img src="../../assets/redeploymentIcon.svg" alt="Redeployment Icon" style="width:25px; margin-left:-6px; margin-right:6px" />  Staff Redeployment Reasons</span>
                  </router-link>
                </li>
                 <li data-menu="" v-if="checkRolePermission('VIEW_FILLED_SHIFT_OUTCOMES')" id=" Filled Shift Reason Configuration">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/Filled-Shift-Configuration"
                    data-toggle="dropdown">
                    <span data-i18n="Feather" id="FilledShift">  <img src="../../assets/horizontalMenu/sliders.svg" alt="Filled Shift Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Filled Shift Reasons</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <li
              class="dropdown nav-item"
              v-if="checkRolePermission('VIEW_COMPLETED_ENDORSEMENT_REQUESTS') || checkRolePermission('VIEW_PENDING_ENDORSEMENT_REQUESTS')"
              v-show="checkAccess('Facilitators')"
              data-menu="dropdown">
              <a class="dropdown-toggle nav-link d-flex align-items-center" href="#" data-toggle="dropdown" data-testid="nav-endorsement-dropdown">
                <span data-i18n="Feather"><img src="../../assets/horizontalMenu/settings.svg" alt="Endorsement Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Endorsement</span>
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" v-if="checkRolePermission('VIEW_PENDING_ENDORSEMENT_REQUESTS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/pendingEndorsementRequestList"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-pending-endorsement">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/list.svg" alt="List Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Pending Endorsement</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_COMPLETED_ENDORSEMENT_REQUESTS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/completedEndorsementRequestList"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-completed-endorsement">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/list.svg" alt="List Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Completed Endorsement</span>
                  </router-link>
                </li>
              </ul>
            </li>

            
            <li class="dropdown nav-item" data-menu="dropdown" v-if="organizationkMenuPermission()">
              <a
                id="Organization"
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-organization-dropdown">
                <span data-i18n="Forms &amp; Tables"> <img src="../../assets/horizontalMenu/organizationMenu.png" alt="User Icon" /> Organization</span>
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" v-if="checkRolePermission('VIEW_TRUST_LIST')" id="Trust">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/trust-lists"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust"><img src="../../assets/horizontalMenu/folder.svg" alt="Trust Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />
                    <span data-i18n="Form Layout">Trust</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_TRUST_DETAILS') && !checkRolePermission('VIEW_TRUST_LIST')" id="Trust Details">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    :to="`/trust/${currentTrustId}/statistics-details`"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust-details">
                    <span data-i18n="Form Layout"><img src="../../assets/horizontalMenu/folder.svg" alt="Trust Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />   Trust Details</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_TRUST_CARE_SPECIALITIES')" id="Care Specialities List">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/trust-care-specialities"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-care-specialities">
                    <img src="../../assets/horizontalMenu/list.svg" alt="list Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Care Specialities List</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_FEEDBACKS')" id="Feedback" v-show="checkAccess('Feedback')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/feedbacks/list"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-feedbacks">
                    <span data-i18n="Feather"> <img src="../../assets/horizontalMenu/thumbs-up.svg" alt="Feedback Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Feedback</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_ROSTER_AVAILABILITY_SETUP_LIST')" id="rosterAvailability">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/roster-setup-list"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-roster-availability">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/tablet.svg" alt="Roster Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Roster Availability</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_STAFF_USERS_ROSTER_AVAILABILITY')" id="staffRosterAvailability">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/staff-roster-availability-actions"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-staff-roster">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/list.svg" alt="List Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Staff Roster Availability</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_HIFI_AWARDS')" id="HiFiAward">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/HiFiAwards/list"
                    data-toggle="dropdown"
                    data-i18n="Feather"
                    data-testid="nav-hifi-awards">
                    <span data-i18n="Feather"><img src="../../assets/horizontalMenu/award.svg" alt="Award Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />High five awards</span>
                  </router-link>
                </li>
                <li data-menu="" id="Trust-mapping-configuration" v-if="checkRolePermission('MAP_WITH_OPTIMA') && checkAccess('Allocate Optima')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/optima/mapping/configuration"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-optima-mapping">
                    <img src="../../assets/horizontalMenu/grid.svg" alt="Optima Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Optima Mapping</span>
                  </router-link>
                </li>
                <li data-menu="" id="Trust-shift-configuration" v-if="checkRolePermission('MAP_WITH_OPTIMA') && checkAccess('Allocate Optima')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/optima/shift/configuration"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-optima-config">
                    <img src="../../assets/horizontalMenu/pocket.svg" alt="Optima Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Optima Configuration</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="checkRolePermission('VIEW_TRUST_BANDS')" id="Trust-bands">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/trust/bands"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust-bands">
                    <img src="../../assets/horizontalMenu/star.svg" alt="Star Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Bands</span>
                  </router-link>
                </li>
                <li data-menu="" id="Trust-job-titles" v-if="checkRolePermission('VIEW_TRUST_ROLE_TYPES')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/trust/job/titles/type"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust-role-types">
                    <img src="../../assets/horizontalMenu/cpu.svg" alt="Role Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Role Type</span>
                  </router-link>
                </li>
               
              </ul>
            </li>


            <li
              class="dropdown nav-item"
              v-if="checkRolePermission('VIEW_PREFERENCES_CONFIGURATION')"
              data-menu="dropdown">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                id="User Preferences"
                data-toggle="dropdown"
                data-testid="nav-user-preferences-dropdown">
                <span data-i18n="Pages"><img src="../../assets/horizontalMenu/star.svg" alt="Preference Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> User Preferences</span>
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" id="Preferences Settings">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/preferences-configuration"
                    data-toggle="dropdown"
                    data-i18n="Account Settings"
                    data-testid="nav-preferences-settings">
                    <span data-i18n="Account Settings"><img src="../../assets/horizontalMenu/heart.svg" alt="Preference setting Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Preferences Settings</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <li
              v-if="checkRolePermission('VIEW_UNFILLED_SHIFTS') || checkRolePermission('VIEW_NON_PARTICIPANTS_SHIFTS') || checkRolePermission('VIEW_RATE_ESCALATED_SHIFTS')"
              class="dropdown nav-item"
              data-menu="dropdown">
              <a
                id="Shifts"
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-shifts-dropdown">
                <img src="../../assets/horizontalMenu/shiftsMenu.png" alt="Shifts Icon" style="margin-right:8px" /><span data-i18n="Charts &amp; Maps">Shifts</span>
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" id="Shifts List">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/jobs/list"
                    data-toggle="dropdown"
                    data-i18n="Leaflet Maps"
                    data-testid="nav-shifts-list">
                    <img src="../../assets/horizontalMenu/shiftsMenu.png" alt="Model Shifts Icon" style="margin-right:8px" /><span data-i18n="Leaflet Maps">Shifts List</span>
                  </router-link>
                </li>
                <li data-menu="" id="Upload Roster shifts" v-if="checkRolePermission('IMPORT_ROSTER_SHIFTS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/upload-roster-shifts"
                    data-toggle="dropdown">
                    <img src="../../assets/horizontalMenu/shiftsMenu.png" alt="Model Shifts Icon" style="margin-right:8px" />
                    <span data-i18n="Leaflet Maps">Upload Roster shifts</span>
                  </router-link>
                </li>
                <li data-menu="" id="Optima Rejected Users" v-if="checkRolePermission('VIEW_REJECTED_BOOKINGS') && checkAccess('Allocate Optima')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/optima-rejected-users"
                    data-toggle="dropdown"
                    data-testid="nav-optima-rejected">
                    <img src="../../assets/horizontalMenu/shiftsMenu.png" alt="Model Shifts Icon" style="margin-right:8px" /><span data-i18n="Leaflet Maps">Optima Rejected Bookings</span>
                  </router-link>
                </li>
              </ul>
            </li>

             <li
              class="dropdown nav-item"
              v-if="checkRolePermission('VIEW_MANAGER_REPORTS')"
              data-menu="dropdown"
              v-show="checkAccess('Reports')">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-reports-dropdown">
                <span data-i18n="Charts &amp; Maps"><img src="../../assets/horizontalMenu/bar-chart-2.svg" alt="Reports Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Reports</span>
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" id="Trust-job-titles">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/report/skillVisualization"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust-role-types">

                    <img src="../../assets/horizontalMenu/cpu.svg" alt="Role Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Skill Visualization of Staff</span>
                  </router-link>
                </li>
              </ul>
              <!-- <ul class="dropdown-menu">
                <li data-menu="" v-if="currentUserRole === 'ADMIN'">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/reports"
                    data-toggle="dropdown"
                    data-i18n="Leaflet Maps"
                    data-testid="nav-charts-reports">
                    <span data-i18n="Leaflet Maps"><img src="../../assets/horizontalMenu/pie-chart.svg" alt="pie chart Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Charts - Reports</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="currentUserRole === 'MANAGER' && checkRolePermission('VIEW_MANAGER_REPORTS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/manager-reports"
                    data-toggle="dropdown"
                    data-i18n="Leaflet Maps"
                    data-testid="nav-shift-reports">
                    <span data-i18n="Leaflet Maps"><img src="../../assets/horizontalMenu/pie-chart.svg" alt="pie chart Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Shift - Reports</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="currentUserRole === 'MANAGER'">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/cancellation-reports"
                    data-toggle="dropdown"
                    data-i18n="Leaflet Maps"
                    data-testid="nav-cancellation-reports">
                    <span data-i18n="Leaflet Maps"><img src="../../assets/horizontalMenu/pie-chart.svg" alt="pie chart Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Cancellation - Reports</span>
                  </router-link>
                </li>
                <li data-menu="" v-if="currentUserRole === 'MANAGER'" id="journeyReport">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/learning/journey/report"
                    data-toggle="dropdown"
                    data-i18n="Leaflet Maps"
                    data-testid="nav-journey-report">
                    <span data-i18n="Leaflet Maps"><img src="../../assets/horizontalMenu/columns.svg" alt="Journey Report Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Journey Report</span>
                  </router-link>
                </li>
              </ul> -->
            </li>

            
            <li
              v-if="checkRolePermission('VIEW_CAMPAIGNS')"
              class="dropdown nav-item"
              data-menu="dropdown"
              v-show="checkAccess('Campaigns')">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-campaign-dropdown">
                <span data-i18n="Charts" id="Campaign"> <img src="../../assets/horizontalMenu/campaignMenu.png" alt="User Icon" /> Campaign</span>

                
              </a>
              <ul class="dropdown-menu">
                <li data-menu="" id="Dashboard">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/campaign/list"
                    data-toggle="dropdown"
                    data-i18n="Disabled Menu"
                    data-testid="nav-campaign-dashboard">
                    <span data-i18n="Metrics"><img src="../../assets/horizontalMenu/columns.svg" alt="Dashboard Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" />Dashboard</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <li
              v-if="checkRolePermission('VIEW_ENHANCEMENTS_AND_REWARDS') || checkRolePermission('VIEW_ENHANCEMENTS_REASONS')"
              class="dropdown nav-item"
              v-show="checkAccess('Ad hoc Enhancements and rewards')"
              data-menu="dropdown">
              <a
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-ad-hoc-dropdown">
                <span data-i18n="Misc" id="Ad Hoc Enhancements and reward"><img src="../../assets/horizontalMenu/adHocEnhancement.png" alt="Ad Hoc Enhancements Icon" />Ad Hoc Enhancements and reward</span>
              </a>
              <ul class="dropdown-menu" id="Enhancements List">
                <li data-menu="">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/incentive/list"
                    data-toggle="dropdown"
                    data-i18n="Disabled Menu"
                    data-testid="nav-enhancements-list">
                    <span data-i18n="Disabled Menu"><img src="../../assets/horizontalMenu/gift.svg" alt="Enhancement Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Enhancements List</span>
                  </router-link>
                </li>
                <li data-menu="" id="Provisioning">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/incentive/provisonList"
                    data-toggle="dropdown"
                    data-i18n="Disabled Menu"
                    data-testid="nav-provisioning">
                    <span data-i18n="Disabled Menu"><img src="../../assets/horizontalMenu/cpu.svg" alt="Provisioning Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /> Provisioning</span>
                  </router-link>
                </li>
              </ul>
            </li>
             <li class="dropdown nav-item" data-menu="dropdown" v-show="checkAccess('Staff Redeployment')">
              <a
                id="Redeployment"
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-organization-dropdown"
                v-if="checkRolePermission('VIEW_RECONCILIATION_REDEPLOYMENT_REQUESTS') || checkRolePermission('VIEW_MY_RECONCILIATION_REDEPLOYMENT_REQUESTS')">
                <span data-i18n="Forms &amp; Tables"> <img src="../../assets/redeploymentIcon.svg" alt="Redeployment Icon" style="width:25px; margin-left:-6px; margin-right:6px" /> Redeployment</span>
              </a>
              
              <ul class="dropdown-menu">
                 <li data-menu="" id="Trust-job-titles" v-if="checkRolePermission('VIEW_RECONCILIATION_REDEPLOYMENT_REQUESTS') || checkRolePermission('VIEW_MY_RECONCILIATION_REDEPLOYMENT_REQUESTS')" v-show="checkAccess('Staff Redeployment')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/redeployment-requests"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    data-testid="nav-trust-role-types">
                    <img src="../../assets/horizontalMenu/cpu.svg" alt="Role Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Redeployment Reconciliation Requests</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="dropdown nav-item" data-menu="dropdown">
              <a
                id="SwapRequests"
                class="dropdown-toggle nav-link d-flex align-items-center"
                href="#"
                data-toggle="dropdown"
                data-testid="nav-organization-dropdown"
               v-if="checkRolePermission('VIEW_STAFF_SWAP_REQUESTS') || checkRolePermission('VIEW_MY_STAFF_SWAP_REQUESTS') || checkRolePermission('FIND_THE_REQUESTED_SWAPS_SENT_TO_THE_STAFF_USERS')"
               >

                <span data-i18n="Forms &amp; Tables"> <img src="../../assets/managerSwapIcons/repeatIcon.svg" alt="Swap  Icon" style="width:20px; margin-left:-6px; margin-right:6px" />Swap Requests</span>
              </a>
              <ul class="dropdown-menu">
                 <li data-menu="" id="Trust-job-titles">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/staff-swap-requests"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    v-if="checkRolePermission('VIEW_STAFF_SWAP_REQUESTS') || checkRolePermission('VIEW_MY_STAFF_SWAP_REQUESTS')"
                    data-testid="nav-trust-role-types">

                    <img src="../../assets/horizontalMenu/cpu.svg" alt="Role Icon" style="width:17px; height:20px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Staff Swap Requests</span>
                  </router-link>
                </li>
                 <li data-menu="" id="Trust-job-titles">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    to="/manager-swap-requests"
                    data-toggle="dropdown"
                    data-i18n="Form Layout"
                    v-if="checkRolePermission('VIEW_MY_STAFF_SWAP_REQUESTS') || checkRolePermission('FIND_THE_REQUESTED_SWAPS_SENT_TO_THE_STAFF_USERS')"
                    data-testid="nav-trust-role-types">
                    <img src="../../assets/redeploymentIcon.svg" alt="Role Icon" style="width:20px; height:21px;margin-bottom: 2px; margin-right:8px" /><span data-i18n="Form Layout">Manager Swap Requests</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import feather from 'feather-icons';
import { useStore } from 'vuex';
import _ from 'lodash';
import { roleType, checkPermission } from '../../constants/roleCheck.js';

// Store setup
const store = useStore();

// Reactive state
const currentUserRoleType = ref('');
const currentUserRoleLevel = ref('');

// Computed properties from store
const account = computed(() => store.state.account);
const currentUserRolePermissions = computed(() => store.state.currentUserRolePermissions);
const currentUserRole = computed(() => store.state.usersStore.currentUserRoleType);
const globalFeaturelist = computed(() => store.state.organizationStore.globalFeaturelist);
const currentTrustId = computed(() => store.state.organizationStore.currentTrustId);
const isSwitching = computed(() => store.state.organizationStore.isSwitching);

// Lifecycle hooks
onMounted(() => {
	feather.replace();
	const resultRoleType = roleType(account.value.newUserRoles);
	if (resultRoleType) {
		// eslint-disable-next-line no-use-before-define
		setCurrentUserRoleType(resultRoleType?.role);
		const currentRoleLocal = window.localStorage.getItem('currentUserRole');
		// eslint-disable-next-line vue/max-len
		const filterRole = account.value.newUserRoles.filter((item) => item.roleId === currentRoleLocal);
		if (filterRole && filterRole.length > 0) {
			// eslint-disable-next-line no-use-before-define
			setCurrentUserRoleType(filterRole[0]?.role?.length > 0 && filterRole[0]?.role[0]?.roleLevel === null ? 'SUPER-ADMIN' : filterRole[0]?.role[0]?.roleLevel);
			// eslint-disable-next-line no-use-before-define
			setCurrentTrustId(filterRole[0].trustId);
			// eslint-disable-next-line no-use-before-define
			setCurrentUserRoleLevel(filterRole[0].roleType);
		}
	}
});

// Methods
// eslint-disable-next-line no-shadow
function setCurrentUserRoleType(roleType) {
	currentUserRoleType.value = roleType;
	store.commit('SET_CURRENT_USER_ROLE_TYPE', roleType);
}

function setCurrentUserRoleLevel(roleLevel) {
	currentUserRoleLevel.value = roleLevel;
	store.commit('SET_CURRENT_USER_ROLE_LEVEL', roleLevel);
}

function setCurrentTrustId(trustId) {
	store.dispatch('setCurrentTrustId', trustId);
}

function checkAccess(name) {
	if (globalFeaturelist.value.includes(name)) {
		return true;
	}
	return false;
}

function checkRolePermission(item) {
	const result = checkPermission(currentUserRolePermissions.value, item);
	return result;
}

function skillMenuPermission() {
	const allPermissions = [
		'VIEW_MASTER_PERSONAS', 'VIEW_TRUST_PERSONAS',
		'VIEW_PERSONA_MAPPINGS',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, allPermissions);
	return findCommon.length > 0;
}

function organizationkMenuPermission() {
	const allPermissions = [
		'VIEW_FEEDBACKS', 'VIEW_TRUST_CARE_SPECIALITIES', 'VIEW_TRUST_BANDS', 'VIEW_TRUST_ROLE_TYPES', 'MAP_WITH_OPTIMA',
		'VIEW_TRUST_DETAILS', 'VIEW_TRUST_LIST', 'VIEW_ROSTER_AVAILABILITY_SETUP_LIST', 'VIEW_STAFF_USERS_ROSTER_AVAILABILITY', 'VIEW_HIFI_AWARDS',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, allPermissions);
	return findCommon.length > 0;
}

function settingRolePermissions() {
	const allPermissions = [
		'VIEW_BAND_ROLETYPE_MAPPINGS', 'VIEW_NOTIFICATIONS_SETTINGS', 'VIEW_AUTO_OFFER_CONFIGURATIONS',
		'VIEW_HIFI_AWARD_REASONS', 'VIEW_BOOKING_RESTRICTION_REASONS', 'VIEW_PRIVACY_POLICIES', 'VIEW_PRODUCT_CONFIGURATIONS', 'VIEW_ROLE_TYPES',
		'VIEW_BAND_TYPES', 'VIEW_WEIGHT_ADJUSTER_SCALE', 'VIEW_PAY_RATES_CONFIGURATION', 'VIEW_MASTER_CARE_SPECIALITIES',
		'VIEW_NFI', 'VIEW_STAFF_PROFILE_CONFIGURATIONS', 'VIEW_CHECKLIST_FOR_RATE_ESCALATION', 'VIEW_RATE_APPROVAL_REASONS',
		'VIEW_RATE_TIER_CONFIGURATIONS', 'VIEW_RATE_REJECTION_REASONS', 'VIEW_SHIFT_CANCELLATION_REASONS', 'VIEW_CHECKLIST_FOR_DRAFTED_SHIFTS',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, allPermissions);
	return findCommon.length > 0;
}

function userMenuPermissions() {
	const allPermissions = [
		'VIEW_MODAL_SHIFTS', 'VIEW_APPLICANTS', 'VIEW_PENDING_APPLICANTS',
		'VIEW_REJECTED_APPLICANTS', 'VIEW_APPROVED_APPLICANTS', 'VIEW_INVITED_MANAGERS', 'VIEW_DELETED_USERS', 'VIEW_REJECTED_USERS',
		'VIEW_APPROVED_USERS', 'VIEW_TRUST_ROLES', 'VIEW_MASTER_ROLES', 'FIND_STAFF_USERS',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, allPermissions);
	return findCommon.length > 0;
}
</script>

<style lang="scss">
@media (max-width: 575.98px) {

    html .navbar-floating.footer-static .app-content .content-area-wrapper,
    html .navbar-floating.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 1.3rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 1.3rem + 0rem));
    }
}

html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 1.3rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 1.3rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
    html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 1.3rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 1.3rem + 0rem));
    }
}

html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 1.3rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 1.3rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
    html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 1.3rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 1.3rem + 0rem));
    }
}

html .navbar-hidden .app-content {
    padding: 2rem 2rem 0 2rem !important;
}

html .navbar-hidden.footer-static .app-content .content-area-wrapper,
html .navbar-hidden.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 0rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 0rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-hidden.footer-static .app-content .content-area-wrapper,
    html .navbar-hidden.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 0rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 0rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 0rem + 0rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 0rem + 0rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 0rem + 0rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 0rem + 0rem + 0rem + 0rem));
    }
}

html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 0rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 0rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 0rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 0rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-static .main-menu {
    top: 0;
}

html .navbar-static .content {
    min-height: calc(100% - calc(4.45rem + 3.35rem));
}

html .navbar-static .app-content {
    padding: 2rem 2rem 0 2rem;
}

html .navbar-static.footer-static .app-content .content-area-wrapper,
html .navbar-static.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-static.footer-static .app-content .content-area-wrapper,
    html .navbar-static.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-static.footer-hidden .app-content .content-area-wrapper,
html .navbar-static.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-static.footer-hidden .app-content .content-area-wrapper,
    html .navbar-static.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 0rem + 0rem));
    }
}

html .navbar-static.footer-fixed .app-content .content-area-wrapper,
html .navbar-static.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-static.footer-fixed .app-content .content-area-wrapper,
    html .navbar-static.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-sticky .app-content {
    padding: calc(2rem + 4.45rem) 2rem 0 2rem;
}

html .navbar-sticky.footer-static .app-content .content-area-wrapper,
html .navbar-sticky.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-sticky.footer-static .app-content .content-area-wrapper,
    html .navbar-sticky.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 1) - calc(0.8rem * 1)) + 4.45rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 0rem + 0rem + 0rem));
    }
}

html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 0rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 0rem));
}

@media (max-width: 575.98px) {

    html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem * 2) - calc(0.8rem * 2)) + 4.45rem + 3.35rem + 0rem + 0rem));
    }
}

html .navbar-static .nav.header-navbar .navbar-container,
html .navbar-sticky .nav.header-navbar .navbar-container {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
}

html .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show,
html .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {
    width: 98%;
    left: 1%;
}

.sp-nav-bar {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    border-radius: 0 !important;
    min-height: auto !important;
}

.main-menu {
    z-index: 1031;
    position: absolute;
    display: table-cell;
    height: 100%;
    overflow: hidden;
}

.main-menu.menu-light {
    color: #6e6b7b;
    background: #fff;
}

.main-menu.menu-light .navigation {
    background: #fff;
}

.main-menu.menu-light .navigation .navigation-header {
    color: #a6a4b0;
    margin: calc(2rem + 0.286rem) 0 0.8rem 2.2rem;
    padding: 0;
    line-height: 1.5;
    letter-spacing: 0.01rem;
}

.main-menu.menu-light .navigation .navigation-header span {
    font-weight: 500;
}

.main-menu.menu-light .navigation li.has-sub>a {
    transition: all 0.5s ease, background 0s, color 0s;
}

.main-menu.menu-light .navigation li a {
    color: #625f6e;
    padding: 10px 15px 10px 15px;
    line-height: 1.45;
}

.main-menu.menu-light .navigation li a span.menu-sub-title {
    color: #bdbbc4;
}

.main-menu.menu-light .navigation li a>* {
    transition: transform 0.25s ease;
}

.main-menu.menu-light .navigation li.nav-item a:hover>* {
    transition: transform 0.25s ease;
    transform: translateX(5px);
}

.main-menu.menu-light .navigation li.nav-item ul.menu-content li a:hover>* {
    transition: transform 0.25s ease;
    transform: translateX(5px);
}

.main-menu.menu-light .navigation>li>a {
    margin: 0 15px;
}

.main-menu.menu-light .navigation>li>a .label {
    margin-top: 4px;
    margin-right: 5px;
}

.main-menu.menu-light .navigation>li>a i,
.main-menu.menu-light .navigation>li>a svg {
    position: relative;
    top: 1px;
}

.main-menu.menu-light .navigation>li>ul li:first-of-type {
    margin-top: 7px !important;
}

.main-menu.menu-light .navigation>li>ul li:not(.has-sub) {
    margin: 0 15px;
}

.main-menu.menu-light .navigation>li>ul li.has-sub>a {
    margin: 0 15px;
}

.main-menu.menu-light .navigation>li>ul li.has-sub>ul>li {
    margin: 0 15px;
}

.main-menu.menu-light .navigation>li.open:not(.menu-item-closing)>a,
.main-menu.menu-light .navigation>li.sidebar-group-active>a {
    color: #565360;
    background: whitesmoke;
    border-radius: 6px;
}

.main-menu.menu-light .navigation>li:not(.open)>ul {
    display: none;
}

.main-menu.menu-light .navigation>li:not(.open)>ul .active {
    background: transparent;
    box-shadow: none;
}

.main-menu.menu-light .navigation>li.active {
    z-index: 1;
}

.main-menu.menu-light .navigation>li.active>a {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
    color: #fff;
    font-weight: 400;
    border-radius: 4px;
}

.main-menu.menu-light .navigation>li .active {
    background: #f0f0f0;
}

.main-menu.menu-light .navigation>li .active>a {
    color: #7367f0;
    margin-bottom: 0;
}

.main-menu.menu-light .navigation>li .active .hover>a,
.main-menu.menu-light .navigation>li .active :hover>a {
    background: whitesmoke;
}

.main-menu.menu-light .navigation>li ul {
    padding: 0;
    margin: 0;
}

.main-menu.menu-light .navigation>li ul li {
    color: #6e6b7b;
    background: transparent;
}

.main-menu.menu-light .navigation>li ul li>a {
    padding: 10px 15px 10px 20px;
}

.main-menu.menu-light .navigation>li ul li ul a {
    padding: 10px 15px 10px 53px;
}

.main-menu.menu-light .navigation>li ul .has-sub:not(.open)>ul {
    display: none;
}

.main-menu.menu-light .navigation>li ul .has-sub:not(.open)>ul .active {
    background: transparent;
    box-shadow: none;
}

.main-menu.menu-light .navigation>li ul .open>a,
.main-menu.menu-light .navigation>li ul .sidebar-group-active>a {
    color: #6e6b7b;
    background: whitesmoke;
    border-radius: 6px;
}

.main-menu.menu-light .navigation>li ul .open>ul,
.main-menu.menu-light .navigation>li ul .sidebar-group-active>ul {
    display: block;
}

.main-menu.menu-light .navigation>li ul .open>ul .open>ul,
.main-menu.menu-light .navigation>li ul .sidebar-group-active>ul .open>ul {
    display: block;
}

.main-menu.menu-light .navigation>li ul .hover>a,
.main-menu.menu-light .navigation>li ul:hover>a {
    color: #787486;
}

.main-menu.menu-light .navigation>li ul .active {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
    border-radius: 4px;
    z-index: 1;
}

.main-menu.menu-light .navigation>li ul .active>a {
    color: #fff;
}

.main-menu.menu-dark {
    color: #dcdcdc;
    background: #10163a;
}

.main-menu.menu-dark .navigation {
    background: #10163a;
}

.main-menu.menu-dark .navigation .navigation-header {
    color: white;
    margin: calc(2rem + 0.286rem) 0 0.8rem 2.2rem;
    padding: 0;
    line-height: 1.5;
    letter-spacing: 0.01rem;
}

.main-menu.menu-dark .navigation .navigation-header span {
    font-weight: 500;
}

.main-menu.menu-dark .navigation li.has-sub>a {
    transition: all 0.5s ease, background 0s, color 0s;
}

.main-menu.menu-dark .navigation li a {
    color: #d0d0d0;
    padding: 10px 15px 10px 15px;
    line-height: 1.45;
}

.main-menu.menu-dark .navigation li a span.menu-sub-title {
    color: white;
}

.main-menu.menu-dark .navigation li a>* {
    transition: transform 0.25s ease;
}

.main-menu.menu-dark .navigation li.nav-item a:hover>* {
    transition: transform 0.25s ease;
    transform: translateX(5px);
}

.main-menu.menu-dark .navigation li.nav-item ul.menu-content li a:hover>* {
    transition: transform 0.25s ease;
    transform: translateX(5px);
}

.main-menu.menu-dark .navigation>li>a {
    margin: 0 15px;
}

.main-menu.menu-dark .navigation>li>a .label {
    margin-top: 4px;
    margin-right: 5px;
}

.main-menu.menu-dark .navigation>li>a i,
.main-menu.menu-dark .navigation>li>a svg {
    position: relative;
    top: 1px;
}

.main-menu.menu-dark .navigation>li>ul li:first-of-type {
    margin-top: 7px !important;
}

.main-menu.menu-dark .navigation>li>ul li:not(.has-sub) {
    margin: 0 15px;
}

.main-menu.menu-dark .navigation>li>ul li.has-sub>a {
    margin: 0 15px;
}

.main-menu.menu-dark .navigation>li>ul li.has-sub>ul>li {
    margin: 0 15px;
}

.main-menu.menu-dark .navigation>li.open:not(.menu-item-closing)>a,
.main-menu.menu-dark .navigation>li.sidebar-group-active>a {
    color: #c3c3c3;
    background: #0c102a;
    border-radius: 6px;
}

.main-menu.menu-dark .navigation>li:not(.open)>ul {
    display: none;
}

.main-menu.menu-dark .navigation>li:not(.open)>ul .active {
    background: transparent;
    box-shadow: none;
}

.main-menu.menu-dark .navigation>li.active {
    z-index: 1;
}

.main-menu.menu-dark .navigation>li.active>a {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
    color: #fff;
    font-weight: 400;
    border-radius: 4px;
}

.main-menu.menu-dark .navigation>li .active {
    background: #090d22;
}

.main-menu.menu-dark .navigation>li .active>a {
    color: #7367f0;
    margin-bottom: 0;
}

.main-menu.menu-dark .navigation>li .active .hover>a,
.main-menu.menu-dark .navigation>li .active :hover>a {
    background: #0c102a;
}

.main-menu.menu-dark .navigation>li ul {
    padding: 0;
    margin: 0;
}

.main-menu.menu-dark .navigation>li ul li {
    color: #dcdcdc;
    background: transparent;
}

.main-menu.menu-dark .navigation>li ul li>a {
    padding: 10px 15px 10px 20px;
}

.main-menu.menu-dark .navigation>li ul li ul a {
    padding: 10px 15px 10px 53px;
}

.main-menu.menu-dark .navigation>li ul .has-sub:not(.open)>ul {
    display: none;
}

.main-menu.menu-dark .navigation>li ul .has-sub:not(.open)>ul .active {
    background: transparent;
    box-shadow: none;
}

.main-menu.menu-dark .navigation>li ul .open>a,
.main-menu.menu-dark .navigation>li ul .sidebar-group-active>a {
    color: #dcdcdc;
    background: #0c102a;
    border-radius: 6px;
}

.main-menu.menu-dark .navigation>li ul .open>ul,
.main-menu.menu-dark .navigation>li ul .sidebar-group-active>ul {
    display: block;
}

.main-menu.menu-dark .navigation>li ul .open>ul .open>ul,
.main-menu.menu-dark .navigation>li ul .sidebar-group-active>ul .open>ul {
    display: block;
}

.main-menu.menu-dark .navigation>li ul .hover>a,
.main-menu.menu-dark .navigation>li ul:hover>a {
    color: #e6e6e6;
}

.main-menu.menu-dark .navigation>li ul .active {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    box-shadow: 0 0 10px 1px rgba(115, 103, 240, 0.7);
    border-radius: 4px;
    z-index: 1;
}

.main-menu.menu-dark .navigation>li ul .active>a {
    color: #fff;
}

.main-menu.menu-fixed {
    position: fixed;
}

.main-menu.menu-static {
    height: 100%;
    padding-bottom: calc(100% - 20rem);
}

.main-menu.menu-static .main-menu-content {
    height: unset !important;
}

.main-menu.menu-shadow {
    box-shadow: 0 0 15px 0 rgba(34, 41, 47, 0.05);
}

.main-menu.menu-border {
    border-right: 1px solid #ebe9f1;
}

.main-menu .shadow-bottom {
    display: none;
    position: absolute;
    z-index: 2;
    height: 50px;
    width: 100%;
    pointer-events: none;
    margin-top: -0.7rem;
    filter: blur(5px);
    background: linear-gradient(#fff 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
}

.bordered-layout .main-menu .shadow-bottom {
    background: linear-gradient(#f8f8f8 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
}

.main-menu.menu-native-scroll .main-menu-content {
    overflow-y: scroll !important;
}

.main-menu .navbar-header {
    height: 100%;
    width: 260px;
    height: 4.45rem;
    position: relative;
    padding: 0.35rem 1rem 0.3rem 1.64rem;
    transition: 300ms ease all, background 0s;
}

.main-menu .navbar-header .navbar-brand {
    display: flex;
    align-items: center;
    margin-top: 1.35rem;
    font-size: inherit;
}

.main-menu .navbar-header .navbar-brand .brand-logo img {
    max-width: 36px;
}

.main-menu .navbar-header .navbar-brand .brand-text {
    color: #7367f0;
    padding-left: 1rem;
    margin-bottom: 0;
    font-weight: 600;
    letter-spacing: 0.01rem;
    font-size: 1.45rem;
    animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
}

.main-menu .navbar-header .modern-nav-toggle {
    animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
}

.main-menu .main-menu-content {
    height: calc(100% - 4.45rem) !important;
    position: relative;
}

.main-menu .main-menu-content .ps__rail-y {
    z-index: 3;
}

.main-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.main-menu ul.navigation-main {
    overflow-x: hidden;
    padding-bottom: 0.75rem;
}

.main-menu ul.navigation-main>li:first-child {
    margin-top: 0.5rem;
}

.main-menu a {
    outline: none;
}

.main-menu a:hover,
.main-menu a:focus {
    text-decoration: none;
}

.navigation {
    font-size: 1.1rem;
    font-family: "Montserrat", Helvetica, Arial, serif;
    font-weight: 400;
    overflow-y: hidden;
    padding-bottom: 20px;
}

.navigation .navigation-header {
    font-family: "Montserrat", Helvetica, Arial, serif;
    font-weight: 500;
    line-height: 1.2;
    padding: 12px 22px;
    font-size: 0.9rem;
    text-transform: uppercase;
}

.navigation li {
    position: relative;
    white-space: nowrap;
    outline: none;
}

.navigation li a {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
}

.navigation li a i,
.navigation li a svg {
    height: 11px;
    width: 11px;
    font-size: 11px;
    margin-right: 1.38rem;
}

.navigation li.menu-item-animating {
    transition: height 0.25s ease-in-out;
}

.navigation li.disabled a {
    cursor: not-allowed;
    opacity: 0.65;
    pointer-events: none;
}

@media (max-width: 767.98px) {

    .menu-hide .main-menu,
    .menu-open .main-menu {
        transition: transform 0.25s, top 0.35s, height 0.35s;
    }

    .main-menu {
        transform: translate3d(-240px, 0, 0);
        backface-visibility: hidden;
        perspective: 1000;
    }

    .menu-open .main-menu {
        transform: translate3d(0, 0, 0);
    }
}

horizontal-menu .content {
    margin-left: 0;
}

.horizontal-menu .content.show-overlay .content-overlay {
    z-index: 998 !important;
}

.horizontal-menu .navbar.header-navbar .navbar-container {
    padding: 0.8rem 2rem;
    background-color: #051376;
    ;
}

.horizontal-menu .horizontal-menu-wrapper .header-navbar {
    min-height: 4.45rem;
}

.horizontal-menu footer {
    position: static;
}

.horizontal-menu .horizontal-menu-wrapper {
    //   position: fixed;
    //   top: 62px;
    z-index: 990;
    width: 100%;
}

.horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-container {
    padding: 0 1rem;
    width: 100%;
}

.horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-header {
    display: none;
}

.horizontal-menu .header-navbar {
    background: #fff;
    z-index: 999 !important;
    line-height: 1;
    min-height: auto;
}

.horizontal-menu .header-navbar.navbar-light {
    background: #fff;
}

.horizontal-menu .header-navbar.navbar-horizontal.floating-nav {
    left: 0;
    //top: 62px;
    width: calc(100vw - (100vw - 100%) - calc(2rem * 2));
    background: #fff;
}

.horizontal-menu .header-navbar .navbar-container {
    border-radius: 0;
}

.horizontal-menu .header-navbar.navbar-fixed {
    position: fixed;
    width: 100%;
}

.horizontal-menu .header-navbar.navbar-brand-center .navbar-header {
    position: absolute;
    left: calc(50% - 56px);
    padding: 0;
    z-index: 1000;
}

.horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand {
    display: flex;
    align-items: center;
    margin-right: 0;
    font-size: inherit;
}

.horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-logo img {
    max-width: 36px;
}

.horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
    color: #7367f0;
    padding-left: 1rem;
    margin-bottom: 0;
    font-weight: 600;
    letter-spacing: 0.01rem;
    font-size: 1.45rem;
}

.horizontal-menu .header-navbar.navbar-horizontal .nav-link {
    color: white;
}
/* Target the anchor tag and change text color on hover */
.horizontal-menu .header-navbar.navbar-horizontal .nav-link :hover {
  color: rgb(56, 55, 55);
}

/* Target the image inside the anchor tag and apply filter on hover */
a.nav-link:hover img {
  filter: grayscale(100%) brightness(0.4) !important;
}

.navbar-nav .nav-item > .dropdown-toggle:hover::after {
  border-top-color: rgb(56, 55, 55) !important;
}
/* Ensure text and arrow inherit from nav-link */
.navbar-nav .nav-item .dropdown-toggle {
  color: inherit;
}

/* Ensure the dropdown arrow inherits text color */
.navbar-nav .nav-item .dropdown-toggle::after {
  border-top-color: currentColor;
}

/* On hover over the full nav-item, make text and arrow black */
.navbar-nav .nav-item:hover > .dropdown-toggle {
  color: rgb(56, 55, 55);
}

/* On hover over nav-item, make arrow black too */
.navbar-nav .nav-item:hover > .dropdown-toggle::after {
  border-top-color: rgb(56, 55, 55);
}

.horizontal-menu .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
    left: 0.4rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
}

.horizontal-menu .header-navbar.navbar-horizontal .sidebar-group-active .dropdown-toggle::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu::before {
    display: none;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu {
    min-width: 215px;
    border: none;
    margin-top: 0;
    min-height: 52px;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .disabled {
    pointer-events: none !important;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .disabled a {
    color: #b8c2cc;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
    left: auto;
    position: absolute;
    top: 50%;
    margin-top: -7px;
    right: 1rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-item {
    font-size: 1rem;
    padding-top: 0.68rem;
    padding-bottom: 0.68rem;
    color: white;
    display: flex;
    align-items: center;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu {
    position: relative;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.openLeft .dropdown-menu {
    left: auto !important;
    right: 100% !important;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.sidebar-group-active {
    background: #f8f8f8;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu>.dropdown-menu {
    position: absolute;
    top: 0 !important;
    left: 100% !important;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu>.dropdown-menu i,
.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu>.dropdown-menu svg {
    height: 11px !important;
    width: 11px !important;
    font-size: 11px !important;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li {
    padding-top: 0.05rem;
    padding-bottom: 0.05rem;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>.dropdown-menu a>* {
    transition: all 0.2s ease;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>.dropdown-menu a:hover {
    background-color: transparent;
    color: #6e6b7b;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>.dropdown-menu a:hover>* {
    transform: translateX(5px);
    transition: transform 0.2s ease;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>.dropdown-menu .active>a {
    background: #f8f8f8;
    color: #7367f0;
    font-weight: 500;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>.dropdown-menu .open.active>a {
    color: #6e6b7b;
    font-weight: normal;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li i,
.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li svg {
    margin-right: 0.5rem;
    height: 17px;
    width: 17px;
    font-size: 1.2rem;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>a {
    padding: 0.715rem 1.25rem;
    display: flex;
    margin-right: 0.715rem;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li:hover>a {
    background: #f8f8f8;
    border-radius: 4px;
}

.horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li.active>a {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    box-shadow: 0px 0px 6px 1px rgba(115, 103, 240, 0.6);
    color: #fff;
    border-radius: 4px;
}

.horizontal-menu .navigation-header {
    font-family: inherit;
    color: #929292;
    padding: 8px 20px;
    font-size: 1rem;
    text-transform: uppercase;
}

.horizontal-menu .navbar-dark .nav-item.active>a {
    border-bottom: 2px solid #7367f0;
    background-color: #313c50;
}

.horizontal-layout.navbar-floating .header-navbar-shadow {
    height: 80px;
}

@media (min-width: 1200px) {
    .horizontal-layout.navbar-floating .header-navbar-shadow {
        top: 45px;
    }
}

.horizontal-layout.navbar-floating:not(.blank-page) .app-content {
    padding: calc(2rem + 4.45rem* 2 + 1.3rem) 2rem 0 2rem;
}

.horizontal-layout.navbar-floating .horizontal-menu-wrapper {
    background: linear-gradient(to bottom, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0) 100%);
    background-repeat: repeat-x;
}

.horizontal-layout.navbar-floating.footer-static .app-content .content-area-wrapper,
.horizontal-layout.navbar-floating.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 1.3rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 1.3rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-floating.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + 3.35rem));
    }
}

.horizontal-layout.navbar-floating.footer-hidden .app-content .content-area-wrapper,
.horizontal-layout.navbar-floating.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 1.3rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 1.3rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-floating.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
    }
}

.horizontal-layout.navbar-floating.footer-fixed .app-content .content-area-wrapper,
.horizontal-layout.navbar-floating.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 1.3rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 1.3rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-floating.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
    }
}

.horizontal-layout.navbar-sticky .app-content {
    padding: calc(2rem + 4.45rem* 2) 2rem 0 2rem;
}

.horizontal-layout.navbar-sticky .header-navbar {
    background-color: #f8f8f8;
    box-shadow: none;
}

.horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
    left: 0;
    top: 62px;
    background-color: #fff;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.horizontal-layout.navbar-sticky.footer-static .app-content .content-area-wrapper,
.horizontal-layout.navbar-sticky.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-sticky.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + 3.35rem));
    }
}

.horizontal-layout.navbar-sticky.footer-hidden .app-content .content-area-wrapper,
.horizontal-layout.navbar-sticky.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
    }
}

.horizontal-layout.navbar-sticky.footer-fixed .app-content .content-area-wrapper,
.horizontal-layout.navbar-sticky.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
    }
}

.horizontal-layout.navbar-static .app-content {
    padding: calc(2rem + 4.45rem) 2rem 0 2rem;
}

.horizontal-layout.navbar-static .content {
    min-height: calc(100% - calc(4.45rem + calc(3.35rem + 0.2rem)));
}

.horizontal-layout.navbar-static .header-navbar {
    background-color: #f8f8f8;
    box-shadow: none;
}

.horizontal-layout.navbar-static .horizontal-menu-wrapper {
    position: relative;
}

.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar {
    background: #fff;
}

.horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {
    left: 0;
    width: 100%;
}

.horizontal-layout.navbar-static.footer-static .app-content .content-area-wrapper,
.horizontal-layout.navbar-static.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 4.45rem + calc(3.35rem + 0.2rem) + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + calc(3.35rem + 0.2rem) + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-static.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + calc(3.35rem + 0.2rem)));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 1) + 4.45rem + calc(3.35rem + 0.2rem)));
    }
}

.horizontal-layout.navbar-static.footer-hidden .app-content .content-area-wrapper,
.horizontal-layout.navbar-static.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 0rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-static.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 0rem));
    }
}

.horizontal-layout.navbar-static.footer-fixed .app-content .content-area-wrapper,
.horizontal-layout.navbar-static.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 4.45rem + 3.35rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-static.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 4.45rem + 3.35rem));
    }
}

.horizontal-layout.navbar-hidden.footer-static .app-content .content-area-wrapper,
.horizontal-layout.navbar-hidden.footer-static .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 1) + 0rem + 3.35rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 0rem + 3.35rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-hidden.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-static .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 1) + 0rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 1) + 0rem + 3.35rem));
    }
}

.horizontal-layout.navbar-hidden.footer-hidden .app-content .content-area-wrapper,
.horizontal-layout.navbar-hidden.footer-hidden .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 0rem + 0rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 0rem + 0rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-hidden .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 0rem + 0rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 0rem + 0rem));
    }
}

.horizontal-layout.navbar-hidden.footer-fixed .app-content .content-area-wrapper,
.horizontal-layout.navbar-hidden.footer-fixed .app-content .kanban-wrapper {
    height: calc(100vh - calc(calc(2rem * 2) + 0rem + 3.35rem + 0rem + 4.45rem));
    height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 2) + 0rem + 3.35rem + 0rem + 4.45rem));
}

@media (max-width: 1199.98px) {

    .horizontal-layout.navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-fixed .app-content .kanban-wrapper {
        height: calc(100vh - calc(calc(calc(2rem - 0.8rem) * 2) + 0rem + 3.35rem));
        height: calc(var(--vh, 1vh) * 100 - calc(calc(calc(2rem - 0.8rem) * 2) + 0rem + 3.35rem));
    }
}

.horizontal-layout.vertical-overlay-menu #main-menu-navigation>li>ul>li>a i,
.horizontal-layout.vertical-overlay-menu #main-menu-navigation>li>ul>li>a svg {
    height: 1rem;
    width: 1rem;
    font-size: 1rem;
}

@media (max-width: 1199.98px) {
    .horizontal-layout.horizontal-menu .horizontal-menu-wrapper .header-navbar {
        display: none;
    }

    .horizontal-layout .header-navbar {
        background: #fff;
    }

    .horizontal-layout .app-content {
        padding: calc(4.45rem + calc(2rem - 0.8rem)) calc(2rem - 0.8rem) 0 calc(2rem - 0.8rem) !important;
    }
}

@media (max-width: 575.98px) {
    html body.horizontal-layout.navbar-static .app-content {
        padding: calc(2rem - 0.8rem + 4.45rem) calc(2rem - 0.8rem) 0 calc(2rem - 0.8rem) !important;
    }
}

/*=========================================================================================
    File Name: vertical-overlay-menu.scss
    Description: A overlay style vertical menu with show and hide support. It support
    light & dark version, filpped layout, right side icons, native scroll and borders menu
    item seperation.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, React, Angular, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.vertical-overlay-menu .content {
    margin-left: 0;
}

.vertical-overlay-menu .navbar .navbar-header {
    float: left;
    width: 260px;
}

.vertical-overlay-menu .main-menu,
.vertical-overlay-menu.menu-hide .main-menu {
    opacity: 0;
    transform: translate3d(0, 0, 0);
    transition: width 0.25s, opacity 0.25s, transform 0.25s;
    width: 260px;
    left: -260px;
}

.vertical-overlay-menu .main-menu .navigation>li>a>svg,
.vertical-overlay-menu .main-menu .navigation>li>a>i {
    margin-right: 14px;
    float: left;
    transition: 200ms ease all;
    height: 20px;
    width: 20px;
}

.vertical-overlay-menu .main-menu .navigation>li>a>svg:before,
.vertical-overlay-menu .main-menu .navigation>li>a>i:before {
    transition: 200ms ease all;
    font-size: 1.429rem;
}

.vertical-overlay-menu .main-menu .navigation li.has-sub>a:after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1rem;
    height: 1rem;
    width: 1rem;
    display: inline-block;
    position: absolute;
    right: 20px;
    top: 14px;
    transform: rotate(0deg);
    transition: all 0.2s ease-out;
}

.vertical-overlay-menu .main-menu .navigation li.has-sub.open:not(.menu-item-closing)>a:after {
    transform: rotate(90deg);
}

.vertical-overlay-menu .main-menu .navigation .navigation-header .feather-more-horizontal {
    display: none;
}

.vertical-overlay-menu.menu-open .main-menu {
    opacity: 1;
    transform: translate3d(260px, 0, 0);
    transition: width 0.25s, opacity 0.25s, transform 0.25s;
}
</style>
